import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=cdbdadc8&"
import script from "../../models/digital-ticket/setting.ts?vue&type=script&lang=ts&"
export * from "../../models/digital-ticket/setting.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports